<script lang="ts">
    import type { Logger, LogLine } from "..";
    import { onMount } from "svelte";

    export let logger: Logger;

    export let logFormat = (line: LogLine) => {
        const message = line.message.format(...(line.args ?? []));
        const level = `[<span style="color: ${colors[line.level]}">${line.level}</span>]`;
        const time = `[<span style="color: #AAA">${formatTime(line.time)}</span>]`;
        return `${time} ${level} ${message}`;
    };


    const { colors, filter: filterStore } = logger;

    let viewer: HTMLDivElement;

    function formatTime(time: number) {
        const date = new Date(time);
        return `${date.getHours().padStart(2, "0")}:${date.getMinutes().padStart(2, "0")}:${date.getSeconds().padStart(2, "0")}.${date.getMilliseconds().padStart(3, "0")}`;
    }

    function addLine(line: LogLine) {
        const div = document.createElement("div");
        div.innerHTML = logFormat(line);

        (div as any).data = line;
        if (!$filterStore(line)) div.classList.add("filter");
        viewer.insertBefore(div, viewer.firstChild);
    }

    $: $filterStore, viewer && updateFilter();

    function updateFilter() {
        for (const child of viewer.children) {
            const line = (child as any).data as LogLine;
            if ($filterStore(line)) {
                child.classList.remove("filter");
            } else {
                child.classList.add("filter");
            }
        }
    }

    onMount(() => {
        logger.getLines().forEach(addLine);
        const res = logger.stream.subscribe(addLine);
        return () => {
            res.unsubscribe();
        };
    });
</script>

<!----------------------------------------------------------------------------->

<div bind:this={viewer} class="log-viewer" />

<!----------------------------------------------------------------------------->

<style>
    .log-viewer {
        display: flex;
        flex-direction: column;
        font-family: var(--font-monospace);
    }

    .log-viewer :global(.filter) {
        display: none;
    }
</style>
